<template>
  <div class="border-1 border border-nash-neutral600 rounded-lg p-3 mb-2">
    <div class="flex flex-row justify-between items-center gap-2">
      <div
        id="pointer-subtask-title"
        v-tooltip.left="'Open inbound text for this member'"
        class="font-bold cursor-pointer"
        @click="goToText"
      >
        {{ formattedTitle }}
      </div>
      <TMTertiaryButton
        :icon-size="IconSize.MD"
        icon-pos="left"
        icon="heroicons:arrow-top-right-on-square"
        class="!text-nash-neutral600 p-0 w-full h-full"
        @click="goToText"
      />
    </div>
    <div class="flex flex-row items-center space-x-2 mt-1 text-nash-neutral700">
      <span> {{ subtask.memberName }} </span>
      <div class="bullet"></div>
      <span> {{ subtask.textReceivedStr }} </span>
    </div>
  </div>
</template>

<script lang="ts">
import TMTertiaryButton from '@thyme/nashville/src/components/button/TMTertiaryButton.vue'
import { defineComponent } from 'vue'

import { setup } from './controller'
import { RespondToTextSubtaskProps } from './types'

export default defineComponent({
  components: {
    TMTertiaryButton,
  },
  props: RespondToTextSubtaskProps,
  emits: ['close'],
  setup,
})
</script>
<style lang="scss" scoped>
.bullet:after {
  @apply text-nash-neutral700;
  content: '•';
}
</style>
